import {IServiceFactory} from "../service-factory.interface";

export class FirebaseAnalyticsReporter {
    constructor(private readonly services: IServiceFactory) {
    }

    sendConnectionSuccess(){
        this._sendElasticEvent('FIREBASE_CONNECTED');
    }

    sendConnectionFail(label: string, value: string){
        this._sendElasticEvent('FIREBASE_CONNECTION_FAILED', label, value);
    }

    sendSubscriptionError(label: string, value: string){
        this._sendElasticEvent('FIREBASE_SUBSCRIPTION_ERROR', label, value);
    }

    sendMessageUpdate(label: string, value: string){
        this._sendElasticEvent('FIREBASE_MESSAGE_UPDATE', label, value);
    }

    private _sendElasticEvent(action: string, label?: string, value?: string){
        this.services.analytics.sendAnalytics('FIREBASE', action, label, value);
    }
}